import { border2, radius, rem, token } from '@thiememeulenhoff/lit-sdk';
import { css } from 'lit';

export const styles = [
  css`
    ::slotted(*) {
      margin: 0;
    }

    :host([disabled]) {
      :where(.trigger) {
        background: ${token('albert-text-input-background-disabled')};
        color: ${token('albert-text-input-foreground-disabled')};
        cursor: not-allowed;
      }
    }

    :where(.content) {
      background-color: ${token('background-secondary')};
      border-radius: ${radius('small')};
      display: flex;
      flex-direction: column;
      max-block-size: var(--auto-size-available-height);
      max-inline-size: var(--auto-size-available-width);
      min-inline-size: var(--reference-width, 0);
      overflow: hidden;
    }

    :where(.main) {
      overflow: auto;
    }

    :where(.content-container) {
      border: ${border2(1, 'input-border-default')};
      box-shadow: ${token('elevation-shadow-raised')};
      margin: unset;
      overflow: hidden;
      padding: unset;

      :where(.content) {
        position: relative;
      }
    }

    :where(.content-container[radius]) {
      border-radius: ${radius('large')};
    }

    :where(.content-container[arrow]) {
      border: ${border2(1, 'background-secondary')};
      border-radius: ${radius('large')};
      box-shadow: ${token('elevation-shadow-raised')};

      :where(.content) {
        border-radius: ${radius('large')};
      }
    }

    :where(.trigger) {
      display: block;
    }

    :where(.arrow) {
      inset-block-start: ${rem(-24)};
      position: absolute;

      svg {
        block-size: ${rem(32)};
        inline-size: ${rem(30)};
      }
    }

    :host([backdrop]) .trigger {
      position: relative;
    }

    :host([open][backdrop]) .trigger {
      z-index: 1;
    }

    :host([backdrop].closing)::before,
    :host([open][backdrop])::before {
      background-color: var(--tm-elevation-backdrop-color);
      content: '';
      display: block;
      inset: 0;
      position: fixed;
      z-index: 1;
    }

    :host([open][backdrop])::before {
      animation: backdrop-fade-in var(--tm-transition-duration-normal)
        var(--tm-transition-function-ease-in-out) forwards;
    }

    :host([backdrop].closing)::before {
      animation: backdrop-fade-out var(--tm-transition-duration-normal)
        var(--tm-transition-function-ease-in-out) forwards;
    }

    :where(.content-container[backdrop].closing) {
      animation: dropdown-fade-out var(--tm-transition-duration-normal)
        var(--tm-transition-function-ease-in-out) forwards;
    }

    :where(.content-container[backdrop])[open] {
      animation: dropdown-fade-in var(--tm-transition-duration-normal)
        var(--tm-transition-function-ease-in-out) forwards;
    }

    @keyframes backdrop-fade-in {
      from {
        background: transparent;
      }
      to {
        background: var(--tm-elevation-backdrop-color);
      }
    }

    @keyframes backdrop-fade-out {
      from {
        background: var(--tm-elevation-backdrop-color);
      }
      to {
        background: transparent;
      }
    }

    @keyframes dropdown-fade-in {
      from {
        opacity: 0;
      }
      to {
        opacity: 1;
      }
    }

    @keyframes dropdown-fade-out {
      from {
        opacity: 1;
      }
      to {
        opacity: 0;
      }
    }
  `,
];
